import React, { useEffect } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getNotifications,
  getReminders,
} from "./store/actions/general.actions";
import routes from "./routes/index";
import privateRoutes from "./routes/private";
import AuthRoute from "./routes/auth";
import PublicRoute from "./routes/PublicRoute";
import NotFound from "./components/notFound/NotFound";
import Toast from "./components/controls/toast";
import NotificationToast from "./components/controls/toast/NotificationToast";
import RouteSync from "./components/navigation/RouteSync";
import "./styles/base/__globalStyles.scss";
import "./styles/base/_meetingsStyles.scss";
import "./styles/base/_fonts.scss";
import "./styles/base/_typography.scss";
import "./styles/base/_variables.scss";
import "./styles/base/normalize.scss";
import { generalActions } from "./store/actions";
import getItemFromLocalStorage from "./utils/getItemFromLocalStorage";
import signalRService from "./store/services/signalRService";
import { scheduleTokenRefresh } from "./helpers/tokenManager";

function App() {
  const dispatch = useDispatch();
  const token = getItemFromLocalStorage("accessToken");

  useEffect(() => {
    if (token) scheduleTokenRefresh();
  }, [token]);

  useEffect(() => {
    if (!token) return;

    let isMounted = true;

    const handleNotification = (data) => {
      dispatch(getNotifications());
      dispatch(generalActions.showNotificationToast(data));
    };

    const handleReminder = (data) => {
      dispatch(getReminders());
      dispatch(generalActions.showNotificationToast(data));
    };

     // Initialize SignalR connection and register event handlers.
    const initConnection = async () => {
      signalRService.on("notification", handleNotification);
      signalRService.on("reminder", handleReminder);

      await signalRService.start();

      if (!isMounted) {
        signalRService.off("notification", handleNotification);
        signalRService.off("reminder", handleReminder);
        signalRService.stop();
      }
    };

    initConnection();

    return () => {
      isMounted = false;
      signalRService.off("notification", handleNotification);
      signalRService.off("reminder", handleReminder);
      signalRService.stop();
    };
  }, [token, dispatch]);

  useEffect(() => {
    if (token) {
      dispatch(getReminders());
      dispatch(getNotifications());
    }
  }, [token, dispatch]);

  const location = useLocation();
  return (
    <div>
      <Toast />
      <NotificationToast />
      <RouteSync />
      <div>
        <Switch>
          {privateRoutes &&
            privateRoutes.map((route, key) => (
              <AuthRoute
                key={key}
                path={route.path}
                url={location.pathname}
                component={route.component}
                routeRole={route.role}
              />
            ))}
          {routes &&
            routes.map((route, key) => (
              <PublicRoute
                key={key}
                path={route.path}
                component={route.component}
              />
            ))}
          <Redirect exact from="/login" to="/" />
          <Route component={NotFound} />
        </Switch>
      </div>
    </div>
  );
}

export default App;
